module.exports = __webpack_public_path__ + "static/media/calendarGraphicSuites.0e6cc0fe.png";